export default __webpack_public_path__ + "static/media/ic-paymentmethod.eff8c7dc.svg";